// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportGetOptInWithCreditTrackingHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking,
  RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Path,
} from '@zg-rentals/ts-rent-payment-client';

import type {
  RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
  RentCreditReportGetOptInWithCreditTrackingWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export type RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Options = UseQueryOptions<
  RentCreditReportGetOptInWithCreditTrackingWebApiResponseDto,
  unknown,
  RentCreditReportGetOptInWithCreditTrackingWebApiResponseDto,
  readonly [string, RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto]
>;

const RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_GetKey = (
  postData: RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
) => [RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Path, postData] as const;

export const RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_queryOptions = (
  postData: RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_GetKey(postData),
    queryFn: () => RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get opt in status for rent reporting with credit tracking
 */
export const useRentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking = (
  postData: RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<
    RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_queryOptions(postData, {
      httpClient,
    }),
    ...options,
  });
};
useRentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking.getKey =
  RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_GetKey;
